
import { useState } from "react";

const OPTIONS = [
  { id: 1, label: "by Competition" },
  { id: 2, label: "by Matched" },
  { id: 3, label: "by Time" },
];

const SortDropdown = ({ selectedOption, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="s-relative s-z-20 s-w-133px s-flex s-items-center s-p-7px s-text-11px s-rounded-5px s-sort-Filter s-bg-filter-background-light dark:s-bg-filter-background-dark s-whitespace-nowrap">
      <span className="s-icon-sort s-flex s-items-center s-justify-center s-mr-3px s-text-11px s-text-black-600 dark:s-text-black-500" />
      <button className="s-text-left s-w-full" onClick={() => setIsOpen((o) => !o)}>
        <div className="s-flex s-gap-3px s-justify-start s-items-center">
          <span className="s-text-14px s-text-global-font-default-light dark:s-text-global-font-default-dark">
            {selectedOption}
          </span>
          <span className={`s-icon-arrow-down s-transform s-text-11px s-transition-transform s-origin-center s-duration-300 s-text-sort-by-icon ${isOpen ? "rotate-180" : ""}`} />
        </div>
      </button>

      {isOpen && (
        <div style={{ background: "#20232a", zIndex: 999999 }} className="s-drop-down s-w-full s-left-0 s-text-15px s-absolute s-top-8 -s-mt-1 s-z-10">
          <div className="s-options s-flex s-flex-col s-sort-Filter s-rounded s-rounded-t-none s-whitespace-nowrap s-bg-filter-background-light dark:s-bg-filter-background-dark">
            {OPTIONS.filter((o) => o.label !== selectedOption).map((option) => (
              <p
                key={option.id}
                className="s-item s-flex s-items-center s-pt-5px s-pb-7px s-px-6 s-cursor-pointer s-text-global-font-default-light dark:s-text-global-font-default-dark"
                onClick={() => { onSelect(option.label); setIsOpen(false); }}
              >
                <span className="s-item-text s-relative s-text-14px">{option.label}</span>
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SortDropdown;